import * as React from "react"
import * as ReactDOM from "react-dom"
import { Moment } from 'moment';
import * as moment from 'moment';
import { FocusedInputShape } from 'react-dates';

import PeopleSelection from '../../../advert_detail/period_selection/mobile/people_selection'
import AdvertPeriodPicker from '../../../utils/period_picker/AdvertPeriodPicker'

import { StartEnd } from '../../../utils/period_picker/PeriodPicker'
import * as PeriodEventEmitter from '../../../utils/period_picker/PeriodEventEmitter'
import * as PeopleEventEmitter from '../../../utils/period_picker/PeopleEventEmitter'
import IsSameMoment from '../../../utils/IsSameMoment'

type Props = {
  advert_id: number
  arrival_date: Moment,
  departure_date: Moment,
  max_people_select: number
  max_people: number
}

type State = {
  max_people: number
  arrival_date: Moment,
  departure_date: Moment,
  period_open: boolean
  focusedInput: FocusedInputShape
}

declare var I18n : { locale: string, t: (_:string) => string }

export default class MobilePeriodSelection extends React.Component<Props, State> {
  subscriptionToken: string
  peopleSubscriptionToken: string

  constructor(props : Props, context) {
    super(props, context)
    this.state = {
      arrival_date: this.props.arrival_date ? moment(this.props.arrival_date, "DD-MM-YYYY") : null,
      departure_date: this.props.departure_date ? moment(this.props.departure_date,   "DD-MM-YYYY") : null,
      max_people: this.props.max_people,
      period_open: false,
      focusedInput: null,
    }
  }

  componentWillMount() {
    this.subscriptionToken = PeriodEventEmitter.subscribe((payload: PeriodEventEmitter.EventPayload) => {
      const arrival_date = payload.start_date
      const departure_date = payload.end_date

      if (!IsSameMoment(this.state.arrival_date, payload.start_date) || !IsSameMoment(this.state.departure_date, payload.end_date)) {
        this.setState({ arrival_date: arrival_date, departure_date: departure_date })
      }
    })

    this.peopleSubscriptionToken = PeopleEventEmitter.subscribe((payload: PeopleEventEmitter.EventPayload) => {
      if (payload.max_people != this.state.max_people) {
        this.setState({ max_people: payload.max_people })
      }
    })
  }

  componentWillUnmount() {
    PeriodEventEmitter.unsubscribe(this.subscriptionToken)
    PeopleEventEmitter.unsubscribe(this.peopleSubscriptionToken)
  }

  hasPeriod() : boolean {
    return this.state.arrival_date != null && this.state.departure_date != null
  }

  componentDidUpdate(prevProps : Props, prevState : State) {
    if (this.state.period_open && !prevState.period_open) {
      this.setState({ focusedInput: 'startDate'})
    }

    if (this.state.max_people != prevState.max_people) {
      PeopleEventEmitter.publish({max_people: this.state.max_people, source: 'period_picker'})
    }
  }

  togglePeriodPicker() {
    this.setState({...this.state, period_open: !this.state.period_open})
  }


  onFocusChange(fi: FocusedInputShape) {
    this.setState({focusedInput: fi}, () => {
      if (fi === null) {
        this.setState({period_open: false})
      }
    });
  }

  onPeopleChange(max_people: number) {
    this.setState({max_people: max_people})
  }

  render() {
    return (
      <div>
        <h3>{I18n.t("rental_adverts.period_selection.availability")}</h3>
        <div>
          <div className="box box--grey-100 box--flex box--brown select--date">
            <div className="box--padding" onClick={() => this.togglePeriodPicker()}>
              {
                this.hasPeriod() ?
                  `${this.state.arrival_date.locale(I18n.locale).format('ddd DD MMM YYYY')} - ${this.state.departure_date.locale(I18n.locale).format('ddd DD MMM YYYY')}`
                : I18n.t("rental_adverts.period_selection.from_to_label")
              }
            </div>
            <div className="box--border-left box--align-right">
              <PeopleSelection
                max_people_select={this.props.max_people_select}
                max_people={this.state.max_people}
                onChange={(people) => this.onPeopleChange(people)}
              />
            </div>
          </div>
        </div>
        {
          (
            this.state.period_open ?
            <AdvertPeriodPicker
              startDate={this.state.arrival_date}
              endDate={this.state.departure_date}
              advert_id={this.props.advert_id}
              onDatesChange={(range: StartEnd) => this.setState({ arrival_date: range.startDate, departure_date: range.endDate})}
              onFocusChange={(fi: FocusedInputShape) => this.onFocusChange(fi)}
              focusedInput={this.state.focusedInput}
              showClearDate={false}
              close={() => this.togglePeriodPicker()}
            /> :
            null
          )
        }
      </div>
    )
  }
}
